import ApiRequest from "../util/ApiRequest";

export default class MemberCourseProgress {
    getUsersProgress = async (courseSubChapterId) => {
        return await ApiRequest.set(`/v1/member_course_progress/${courseSubChapterId}/users`, "GET");
    }
}
